<template>
  <div>
    <!-- <div class="changeTab"> -->
    <!-- <div class="changeTab" @click="changeAct"> -->
      <!-- <span :class="{ tabAct: !changeTabFlag }">现阶段</span>
      <span :class="{ tabAct: changeTabFlag }">预售阶段</span>
      <span :class="{ tabAct: changeTabFlag }">全阶段</span>
    </div> -->
    <div class="conTit">
      <span></span>
      <p>
        {{
          new Date().valueOf() >= 1590854400000
            ? "渠道维度"
            : "渠道维度(含预售)"
        }}
      </p>
    </div>
    <ul class="pro_list">
      <van-row type="flex" justify="center" class="olTit">
        <van-col span="6">
          <p>渠道</p>
        </van-col>
        <van-col span="5">
          <p v-if="changeTabFlag == false">阶段销售额(`000)</p>
          <p v-else>总销售额(`000)</p>
          <!-- <p v-else>销售额(`000)</p> -->
        </van-col>
        <van-col span="5">
          <p v-if="changeTabFlag == false">阶段目标(`000)</p>
          <p v-else>总目标(`000)</p>
          <!-- <p v-else>目标(`000)</p> -->
        </van-col>
        <van-col span="4">
          <p v-if="changeTabFlag == false">阶段完成率</p>
          <p v-else>总完成率</p>
          <!-- <p v-else>完成率</p> -->
        </van-col>
        <van-col span="4">
          <p v-if="changeTabFlag == false">vs.ly同期</p>
          <p v-else>vs.ly</p>
          <!-- <p v-else>vs.ly</p> -->
        </van-col>
      </van-row>
    </ul>
    <div class="box">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="8">全网汇总</van-col>
        <van-col span="4">{{ salesValue | NumFormat }}</van-col>
        <van-col span="4">{{ targetValue | NumFormat }}</van-col>
        <van-col span="4">{{
          achieving == "" ? 0.0 + "%" : achieving
        }}</van-col>
        <van-col span="4">{{ lyValue == "" ? 0.0 + "%" : lyValue }}</van-col>
      </van-row>
    </div>

    <div class="box" v-for="(item, i) in tableList" :key="i">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="8">{{ item.totalChannel }}</van-col>
        <van-col span="4">{{ item.salesValue | NumFormat }}</van-col>
        <van-col span="4">{{ item.targetValue | NumFormat }}</van-col>
        <van-col span="4">{{
          item.achieving == "" ? 0.0 + "%" : item.achieving
        }}</van-col>
        <van-col span="4">{{ item.ly == "" ? 0.0 + "%" : item.ly }}</van-col>
      </van-row>
      <div
        v-show="isShow"
        v-for="(item1, i1) in item.channelList"
        :key="i1"
        @click.prevent="show(i1, $event)"
      >
        <van-row type="flex" justify="center" class="OneTie">
          <div class="red"></div>
          <van-col span="8">{{ item1.channelNm }}</van-col>
          <van-col span="4">{{ item1.salesValue | NumFormat }}</van-col>
          <van-col span="4">{{ item1.targetValue | NumFormat }}</van-col>
          <van-col span="4">{{
            item1.achieving == "" ? 0.0 + "%" : item1.achieving
          }}</van-col>
          <van-col span="4">{{
            item1.ly == "" ? 0.0 + "%" : item1.ly
          }}</van-col>
        </van-row>

        <van-row
          type="flex"
          justify="center"
          v-show="isShow2"
          v-for="(item2, i2) in item1.brandCdList"
          :key="i2"
          class="TwoTie"
        >
          <van-col span="8">{{ item2.brandCd }}</van-col>
          <van-col span="4">{{ item2.salesValue | NumFormat }}</van-col>
          <van-col span="4">{{ item2.targetValue | NumFormat }}</van-col>
          <van-col span="4">{{
            item2.achieving == "" ? 0.0 + "%" : item2.achieving
          }}</van-col>
          <van-col span="4">{{
            item2.ly == "" ? 0.0 + "%" : item2.ly
          }}</van-col>
        </van-row>
      </div>
    </div>

    <div class="conTit">
      <span></span>
      <p>
        {{
          new Date().valueOf() >= 1590854400000
            ? "品牌维度"
            : "品牌维度(含预售)"
        }}
      </p>
    </div>
    <ul class="pro_list">
      <van-row type="flex" justify="center" class="olTit">
        <van-col span="6">
          <p>品牌</p>
        </van-col>
        <van-col span="5">
          <p v-if="changeTabFlag == false">阶段销售额(`000)</p>
          <p v-else>总销售额(`000)</p>
          <!-- <p v-else>销售额(`000)</p> -->
        </van-col>
        <van-col span="5">
          <p v-if="changeTabFlag == false">阶段目标(`000)</p>
          <p v-else>总目标(`000)</p>
          <!-- <p v-else>目标(`000)</p> -->
        </van-col>
        <van-col span="4">
          <p v-if="changeTabFlag == false">阶段完成率</p>
          <p v-else>总完成率</p>
          <!-- <p v-else>完成率</p> -->
        </van-col>
         <van-col span="4">
          <p v-if="changeTabFlag == false">vs.ly同期</p>
          <p v-else>vs.ly</p>
          <!-- <p v-else>vs.ly</p> -->
        </van-col> 
      </van-row>
    </ul>
    <div class="box">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="8">全网汇总</van-col>
        <van-col span="4">{{ salesValue | NumFormat }}</van-col>
        <van-col span="4">{{ targetValue | NumFormat }}</van-col>
        <van-col span="4">{{
          achieving == "" ? 0.0 + "%" : achieving
        }}</van-col>
        <van-col span="4">{{ lyValue == "" ? 0.0 + "%" : lyValue }}</van-col>
      </van-row>
    </div>
    <!-- 一级 -->
    <div class="box" v-for="(item, i) in tableList2" :key="i">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="8">{{ item.cateGory }}</van-col>
        <van-col span="4">{{ item.salesValue | NumFormat }}</van-col>
        <van-col span="4">{{ item.targetValue | NumFormat }}</van-col>
        <van-col span="4">{{
          item.achieving == "" ? 0.0 + "%" : item.achieving
        }}</van-col>
        <van-col span="4">{{ item.ly == "" ? 0.0 + "%" : item.ly }}</van-col>
      </van-row>
      <!-- 二级 -->
      <div
        v-show="isShow"
        v-for="(item1, i1) in item.cateGoryList"
        @click.prevent="show(i1, $event)"
        :key="i1"
      >
        <van-row type="flex" justify="center" class="OneTie">
          <div class="red"></div>
          <van-col span="8">{{ item1.brandCd }}</van-col>
          <van-col span="4">{{ item1.salesValue | NumFormat }}</van-col>
          <van-col span="4">{{ item1.targetValue | NumFormat }}</van-col>
          <van-col span="4">{{
            item1.achieving == "" ? 0.0 + "%" : item1.achieving
          }}</van-col>
          <van-col span="4">{{
            item1.ly == "" ? 0.0 + "%" : item1.ly
          }}</van-col>
        </van-row>

        <van-row
          type="flex"
          justify="center"
          v-show="isShow2"
          v-for="(item2, i2) in item1.channelNmList"
          :key="i2"
          class="TwoTie"
        >
          <van-col span="8">{{ item2.channelNm }}</van-col>
          <van-col span="4">{{ item2.salesValue | NumFormat }}</van-col>
          <van-col span="4">{{ item2.targetValue | NumFormat }}</van-col>
          <van-col span="4">{{
            item2.achieving == "" ? 0.0 + "%" : item2.achieving
          }}</van-col>
          <van-col span="4">{{
            item2.ly == "" ? 0.0 + "%" : item2.ly
          }}</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import { Toast } from "vant";

export default {
  data() {
    return {
      changeTabFlag: true,
      tableList: [],
      tableList2: [],
      isShow: true,
      isShow2: false,
      Proportion: 0,
      salesValue: 0,
      targetValue: 0,
      lyValue: 0,
      achieving: 0,
      brandName: "",
    };
  },
  methods: {
    changeAct() {
      this.changeTabFlag = !this.changeTabFlag;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.getSum();
      this.getList();
      this.getList2();
    },
    addAfter() {
      // console.log($('.TwoTie').siblings('.OneTie'))
    },
    getList() {
      if (this.changeTabFlag == true) {
        this.$addr
          .post(
            "Sales/getTotalChannelData",
            qs.stringify({ brandCd: this.brandName, type: 1 })
          )
          .then((res) => {
            this.tableList = [];
            this.tableList = res.data.data;
            Toast.clear();
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      } else {
        this.$addr
          .post(
            "Sales/getTotalChannelData",
            qs.stringify({ brandCd: this.brandName })
          )
          .then((res) => {
            this.tableList = [];
            this.tableList = res.data.data;
            Toast.clear();
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      }
    },
    getList2() {
      if (this.changeTabFlag == true) {
        this.$addr
          .post(
            "Sales/getCateGoryData",
            qs.stringify({ brandCd: this.brandName, type: 1 })
          )
          .then((res) => {
            this.tableList2 = [];
            this.tableList2 = res.data.data;
            Toast.clear();
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      } else {
        this.$addr
          .post(
            "Sales/getCateGoryData",
            qs.stringify({ brandCd: this.brandName })
          )
          .then((res) => {
            this.tableList2 = [];
            this.tableList2 = res.data.data;
            Toast.clear();
          })
          .catch((error) => {
            this.$toast("接受数据失败");
          });
      }
    },
    getSum() {
      this.$addr.post("Sales/getSalesSumData").then((res) => {
        if (this.changeTabFlag == false) {
          this.achieving = res.data.data[0].today_achieving;
          this.targetValue = res.data.data[0].today_target;
          this.lyValue = res.data.data[0].today_ly;
          this.salesValue = res.data.data[0].today_sales;
        } else if (this.changeTabFlag == true) {
          this.achieving = res.data.data[0].achieving;
          this.targetValue = res.data.data[0].targetValue;
          this.lyValue = res.data.data[0].ly;
          this.salesValue = res.data.data[0].salesValue;
        }
        Toast.clear();
      });
    },
    show(i, e) {
      $(e.currentTarget).stop().find(".TwoTie").slideToggle(500);
    },
  },
  created() {
    this.getList();
    this.getList2();
    this.getSum();
  },
  props: ["brandCd"],
  watch: {
    brandCd: function (newVal, oldVal) {
      if (newVal == "全部店铺") {
        newVal = null;
      }
      this.brandName = newVal;

      this.$addr
        .post("Sales/getSalesData", qs.stringify({ brandCd: this.brandName }))
        .then((res) => {
          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  beforeMount() {
    this.addAfter();
  },
};
</script>
<style scoped>
.changeTab {
  margin: 12px auto;
  width: 90%;
  height: 30px;
  line-height: 30px;
  border: 1px solid #d1534b;
  border-radius: 10px;
  display: flex;
  align-items: center;
  color: #d1534b;
}
.changeTab span {
  display: block;
  width: 100%;
  text-align: center;
}
.tabAct {
  color: #f9f9f9;
  border-radius: 10px;
  background-color: #d1534b;
  height: 100%;
}
.red {
  position: absolute;
  left: 10px;
  top: 15px;
  width: 0;
  height: 0;
  border: 4px solid;
  border-color: red transparent transparent transparent;
}
.pro_list {
  margin: 14px 0 0;
  width: 100%;
  text-align: center;
}
.pro_list .olTit {
  display: flex;
  height: 21px;
  background: rgba(209, 83, 75, 0.3);
  align-items: center;
  justify-content: space-around;
}
.pro_list .olTit p {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #343434;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 14px;
  position: relative;
}
.OneTie {
  position: relative;
  text-align: left;
  width: 100%;
  height: 35px;
  background: #ffffff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  line-height: 35px;
  text-align: center;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #000000;
}
.active {
  width: 103%;
  margin-bottom: 4px;
  margin-left: -7px;
  background: #ffffff;
  box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Semibold";
  font-size: 12px;
  color: #000000;
  font-weight: bold;
}
.TwoTie {
  /* display: none; */
  /* position: absolute; */
  margin-bottom: 2px;
  text-align: center;
  font-family: "PingFangSC-Light";
  font-size: 11px;
  color: #191919;
  width: 100%;
  height: 35px;
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  line-height: 35px;
}

.conTit {
  margin-top: 15px;
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 21px;
  width: 100%;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #ba4d4c;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
</style>


// WEBPACK FOOTER //
// src/components/Pos/table_list.vue